export const aciRoundTrip = {
    iconName: 'round-trip',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 26 24' },
        path: {
            attr: {
                d: 'M10.805 6.98l14.007.09M17.07 12.938L10.805 6.98l6.204-5.877M15.046 17.21l-14.007-.09M8.78 11.252l6.265 5.958-6.204 5.877',
                stroke: 'currentColor',
                'stroke-width': '1.5',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
